module.exports = __webpack_public_path__ + "img/image2.3e6e9d6d.png";